<script setup lang="ts">
import { computed } from 'vue';
import { every, isEmpty } from 'lodash';
import ShowImageByScreen from '@/components/ShowImageByScreen.vue';

interface Props {
  value: any;
}
const props = defineProps<Props>();

const bottomBannerInfo = computed(() => props.value);

const isEmptyDetail = computed(() => {
  return every(props.value, isEmpty);
});
</script>

<template>
  <div v-if="!isEmptyDetail" class="grid grid-nogutter surface-section text-800 bottom-banner-container">
    <div class="overflow-hidden banner-image">
      <ShowImageByScreen alt="image-render" class="w-full md:ml-auto block md:h-full" :images="bottomBannerInfo.image"></ShowImageByScreen>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.bottom-banner-container {
  position: relative;
  overflow: hidden;
}
.banner-image {
  width: 100%;
  height: 320px;
}
.word-break {
  word-break: break-word;
}
</style>
